export default "<span class=\"success\">\r\n   Thank you for your message we'll contact you soon!\r\n</span>\r\n"